module.exports = {"440308001":"梅沙街道","440308002":"盐田街道","440308003":"沙头角街道","440308004":"海山街道","440308403":"深圳盐田综合保税区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440308.json
// module id = 2097
// module chunks = 0